(() => {
  if (window.__preorderCartGuardLoaded) return;
  window.__preorderCartGuardLoaded = true;

  let isRemoving = false;

  function getInvalidLines() {
    const lines = new Map();
    document.querySelectorAll('.preorder-cart-guard-line[data-line-key]').forEach((node) => {
      lines.set(node.dataset.lineKey, {
        key: node.dataset.lineKey,
        productTitle: node.dataset.productTitle || '商品',
        variantTitle: node.dataset.variantTitle || ''
      });
    });
    return Array.from(lines.values());
  }

  function isCheckoutControl(element) {
    return Boolean(element?.closest(
      'button[name="checkout"], input[name="checkout"], a[href*="/checkout"]'
    ));
  }

  async function guardCheckout(event) {
    const lines = getInvalidLines();
    if (!lines.length || isRemoving) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

    isRemoving = true;
    const checkoutButtons = document.querySelectorAll('button[name="checkout"], input[name="checkout"]');
    checkoutButtons.forEach((button) => {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    });

    try {
      const updates = {};
      lines.forEach((line) => { updates[line.key] = 0; });

      const response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) throw new Error(`Cart update failed: ${response.status}`);

      const itemNames = lines.map((line) =>
        `・${line.productTitle}${line.variantTitle && line.variantTitle !== 'Default Title' ? `（${line.variantTitle}）` : ''}`
      ).join('\n');

      window.alert(`部分商品狀態已更新，已從購物車移除，請重新選購後再結帳：\n\n${itemNames}`);
      window.location.reload();
    } catch (error) {
      console.error('[Preorder cart guard]', error);
      window.alert('無法更新購物車，請重新整理頁面後再試一次。');
      checkoutButtons.forEach((button) => {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      });
      isRemoving = false;
    }
  }

  document.addEventListener('click', (event) => {
    if (isCheckoutControl(event.target)) guardCheckout(event);
  }, true);

  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (submitter?.name === 'checkout') guardCheckout(event);
  }, true);
})();